import React from 'react';
import { registry } from '../../core/Registry.js';
import { BaseWidget } from '../BaseWidget.jsx';

export function GalleryRender({ node, isLiveMode }) {
  const content = node.content || {};
  
  // URLs separated by comma
  const rawUrls = content.imageUrls || 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?q=80&w=400,https://images.unsplash.com/photo-1544465544-1b71aee9dfa3?q=80&w=400,https://images.unsplash.com/photo-1510557880182-3d4d3cba35a5?q=80&w=400';
  const imageUrls = rawUrls.split(',').map(url => url.trim()).filter(Boolean);
  
  const columns = parseInt(content.columns, 10) || 3;
  const gap = content.gap || '16px';
  const radius = content.radius || '8px';

  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: `repeat(${columns}, 1fr)`,
      gap: gap,
      width: '100%',
      pointerEvents: !isLiveMode ? 'none' : 'auto' // Verhindert Klicks im Editor
    }}>
      {imageUrls.map((url, idx) => (
        <div key={idx} style={{ 
          aspectRatio: '1 / 1', 
          overflow: 'hidden', 
          borderRadius: radius,
          backgroundColor: 'rgba(255,255,255,0.05)'
        }}>
          <img 
            src={url} 
            alt={`Gallery img ${idx}`} 
            style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.3s ease' }}
            onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.05)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
          />
        </div>
      ))}
    </div>
  );
}

registry.register('Gallery', {
  label: 'Bildergalerie',
  icon: '🖼️', 
  category: 'media',
  component: GalleryRender,
  
  defaultProps: {
    content: {
      imageUrls: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?q=80&w=400,https://images.unsplash.com/photo-1544465544-1b71aee9dfa3?q=80&w=400,https://images.unsplash.com/photo-1510557880182-3d4d3cba35a5?q=80&w=400',
      columns: '3',
      gap: '16px',
      radius: '8px'
    },
    style: {
      desktop: {
        marginBottom: '20px'
      }
    }
  },

  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Bilder',
          fields: [
            { name: 'content.imageUrls', label: 'Bild-URLs (Kommasepariert)', type: 'textarea' }
          ]
        },
        {
          title: 'Grid Layout',
          fields: [
            { name: 'content.columns', label: 'Spaltenanzahl', type: 'select', options: ['1', '2', '3', '4', '5', '6'] },
            { name: 'content.gap', label: 'Abstand (z.B. 16px)', type: 'text' },
            { name: 'content.radius', label: 'Eckenradius (z.B. 8px)', type: 'text' }
          ]
        }
      ]
    }
  ]
});
